import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Container, Grid, Typography } from '@material-ui/core';
import ItemList from 'screens/Lots/components/ItemList';
import Filters from 'screens/Lots/components/Filters';
import { useIsMobileDevice } from 'utils/hooks/isMobileDevice';
import { selectState } from '../../../utils/reduxActions';
import connectSaga from '../../../utils/saga';
import saga from '../saga';
// ui
// components
import WarehouseMovementForm from './WarehouseMovementForm';

import { useTranslation } from 'react-i18next';

function LotsComponent(props) {
  const { t } = useTranslation();
  const headerList = [
    { name: t('Number'), width: '5%', mobileOrder: 1 },
    { name: t('Species'), width: '10%', mobileOrder: 2 },
    { name: t('Variety'), width: '10%', mobileOrder: 3 },
    { name: t('Product'), width: '10%', mobileOrder: 4 },
    { name: t('Date'), width: '10%', mobileOrder: 5 },
    { name: t('Quantity'), width: '10%', mobileOrder: 6 },
    { name: t('Containers'), width: '10%', mobileOrder: 7 },
    { name: t('Lot'), width: '10%', mobileOrder: 8 },
    { name: t('Status'), width: '10%', mobileOrder: 9 },
    { name: '', width: '5%', mobileOrder: 10 },
  ];
  const warehouses = Object.values(props.objects.warehouses).filter((w) => !w.supplyWarehouse);
  const isMobileDevice = useIsMobileDevice();

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={props.classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={props.classes.marginTop}>
            {t('Paks')}
          </Typography>
        </Grid>
        <Filters
          classes={props.classes}
          defaultFilters={props.defaultFilters}
          defaultPagination={props.defaultPagination}
        />
        <ItemList
          classes={props.classes}
          objects={props.objects}
          warehouses={warehouses}
          headerList={headerList}
          isMobileDevice={isMobileDevice}
        />
      </Grid>
      <WarehouseMovementForm warehouses={warehouses} />
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaLots', saga });

const withConnect = connect(selectState('app.objects'), null);

export default compose(withConnect)(withSaga(LotsComponent));
